// extracted by mini-css-extract-plugin
export default {"root":"NotificationGlobalList_root__Ho-NU"};